import type { Project } from '$lib/types/project';
import type { Unit } from '$lib/types/unit';
import { router } from './router.svelte';
import type { EntityType, Route } from './types';

export function navigate(route: Route, opts?: { replace?: boolean }) {
	router.navigate(route, opts);
}

export function goDashboard() {
	router.navigate({ name: 'dashboard' });
}

export function goGuide() {
	router.navigate({ name: 'guide' });
}

export function goAdminUsers() {
	router.navigate({ name: 'admin-users' });
}

export function openProject(project: Project) {
	router.navigate({ name: 'project', projectId: project.id });
}

export function openUnit(unit: Unit) {
	router.navigate({ name: 'unit', unitId: unit.id, entity: null });
}

export function selectEntity(type: EntityType, id: number | null) {
	const route = router.route;
	if (route.name !== 'unit') return;
	router.navigate({ name: 'unit', unitId: route.unitId, entity: { type, id } });
}

export function clearEntity() {
	const route = router.route;
	if (route.name !== 'unit') return;
	router.navigate({ name: 'unit', unitId: route.unitId, entity: null });
}

/** @deprecated Use selectEntity */
export const select = selectEntity;

/** @deprecated Use clearEntity */
export const clearSelection = clearEntity;

/** @deprecated Use openProject */
export const openProjectRoute = openProject;

/** @deprecated Use openUnit */
export const openUnitRoute = openUnit;

/** @deprecated Use router.start() */
export function startRouting() {
	return router.start();
}
